/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountChangeAddressModel,
  AccountChangeEmailModel,
  BadRequest,
  CmsCustomerModel,
  Conflict,
  CreatedCustomerResponseModel,
  CustomerAddFeatureGroupModel,
  CustomerAddModel,
  CustomerBasicResponseModel,
  CustomerChangeSubscriptionsModel,
  CustomerChangeTenantModel,
  CustomerCompareModel,
  CustomerDeactivateModel,
  CustomerFeatureGroupResponseModel,
  CustomerGatewayHealthResponseModel,
  CustomerGlobalSites,
  CustomerIdpProviderResponseModel,
  CustomerRemoveFeatureGroupModel,
  CustomerRemoveModel,
  CustomerResponseModel,
  CustomerStats,
  CustomerStatsChildren,
  CustomerStatsFilter,
  CustomerUpdateModel,
  CustomerUserMainResponseModel,
  CustomerUserResponseModel,
  CustomerUserUpdateModel,
  CustomersFilter,
  CustomersOrder,
  CustomersResponseModel,
  DashboardAccessTokensModel,
  ErrorResponseModel,
  Forbidden,
  GatewayToUReadinessResponseModel,
  HealthStatusAlarmsModel,
  HealthStatusModel,
  HealthStatusRequest,
  InstallationStatsModel,
  NotFound,
  NotImplemented,
  PaginatedActivityLogResponse,
  RequestEntityTooLarge,
  SentInvitationResponseModel,
  TechnicalCustomerAddModel,
  TenantAffiliateResponseModel,
  TooManyRequests,
  Unauthorized,
  UserReactivationModel,
  VendorAllocationPatchModel,
  VendorModel,
} from '../models';

export interface CrmCustomersAddAccountUserRequest {
    customerAddModel: CustomerAddModel;
}

export interface CrmCustomersAddCustomerToSubtenantRequest {
    id: string;
}

export interface CrmCustomersAddTechnicalCustomerRequest {
    technicalCustomerAddModel: TechnicalCustomerAddModel;
}

export interface CrmCustomersAssignFeatureGroupToCustomerRequest {
    id: string;
    customerAddFeatureGroupModel: CustomerAddFeatureGroupModel;
}

export interface CrmCustomersCompareCustomerDataRequest {
    customerId: string;
    configId: string;
    date?: string;
}

export interface CrmCustomersCustomerChangeSiteAddressRequest {
    id: string;
    siteId: string;
    accountChangeAddressModel: AccountChangeAddressModel;
}

export interface CrmCustomersCustomerGetIdpProviderRequest {
    id: string;
}

export interface CrmCustomersCustomerGetSitesRequest {
    id: string;
}

export interface CrmCustomersCustomerUserChangeEmailRequest {
    id: string;
    accountChangeEmailModel: AccountChangeEmailModel;
}

export interface CrmCustomersCustomerUserResetPasswordRequest {
    id: string;
}

export interface CrmCustomersCustomerUserValidateRequest {
    id: string;
}

export interface CrmCustomersDeactivateCustomerRequest {
    id: string;
    customerDeactivateModel: CustomerDeactivateModel;
}

export interface CrmCustomersDeleteCustomerRequest {
    id: string;
    customerRemoveModel: CustomerRemoveModel;
}

export interface CrmCustomersGetAuthTokensRequest {
    id: string;
}

export interface CrmCustomersGetCmsCustomersRequest {
    systemOwners?: boolean;
}

export interface CrmCustomersGetCsvUploadLogsRequest {
    page?: number;
    limit?: number;
    date?: number;
}

export interface CrmCustomersGetCsvUploadLogsForCustomerRequest {
    id: string;
    page?: number;
    limit?: number;
    date?: number;
}

export interface CrmCustomersGetCustomerRequest {
    id: string;
}

export interface CrmCustomersGetCustomerAllocationsRequest {
    customerId: string;
}

export interface CrmCustomersGetCustomerCustomersRequest {
    id: string;
    page?: number;
    limit?: number;
    searchValue?: string;
    filter?: CustomersFilter;
    order?: CustomersOrder;
    csvExport?: boolean;
}

export interface CrmCustomersGetCustomerGatewayHealthRequest {
    id: string;
}

export interface CrmCustomersGetCustomerGatewayHealthHistoryRequest {
    id: string;
}

export interface CrmCustomersGetCustomerInstallationsStatsRequest {
    id: string;
}

export interface CrmCustomersGetCustomerStatsRequest {
    id: string;
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersGetCustomerStatsChildrenRequest {
    id: string;
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersGetCustomerTenantAffiliateRequest {
    id: string;
}

export interface CrmCustomersGetCustomerTouReadinessCheckRequest {
    customerId: string;
}

export interface CrmCustomersGetCustomerUserRequest {
    id: string;
    userId: string;
}

export interface CrmCustomersGetCustomerUserBasicRequest {
    id: string;
    userId: string;
}

export interface CrmCustomersGetCustomerUserIncludingTenantNameRequest {
    id: string;
    tenantUserUid: string;
}

export interface CrmCustomersGetCustomerUsersRequest {
    id: string;
}

export interface CrmCustomersGetCustomersRequest {
    page?: number;
    limit?: number;
    searchValue?: string;
    filter?: CustomersFilter;
    order?: CustomersOrder;
    csvExport?: boolean;
}

export interface CrmCustomersGetInstallationsGatewayAlarmsRequest {
    alarmLevel?: string;
    active?: string;
}

export interface CrmCustomersGetInstallationsHealthRequest {
    healthStatusRequest: HealthStatusRequest;
}

export interface CrmCustomersGetInstallationsHealthAlarmsRequest {
    alarmLevel?: string;
    active?: string;
}

export interface CrmCustomersGetInstallationsHealthAlarmsByCustomerIdRequest {
    customerId: string;
}

export interface CrmCustomersGetSendAccountUserInvitationsRequest {
    id: string;
}

export interface CrmCustomersGetSendUserEmailCampaignsRequest {
    id: string;
}

export interface CrmCustomersGetStatsRequest {
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersGetStatsCustomersRequest {
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersReactivateCustomerRequest {
    id: string;
}

export interface CrmCustomersRemoveAssignedToCustomerFeatureGroupRequest {
    id: string;
    customerRemoveFeatureGroupModel: CustomerRemoveFeatureGroupModel;
}

export interface CrmCustomersSendAccountUserInvitationRequest {
    id: string;
}

export interface CrmCustomersUpdateAccountSubscriptionRequest {
    id: string;
    customerChangeSubscriptionsModel: CustomerChangeSubscriptionsModel;
}

export interface CrmCustomersUpdateAccountUserRequest {
    id: string;
    customerChangeTenantModel: CustomerChangeTenantModel;
}

export interface CrmCustomersUpdateCustomerRequest {
    id: string;
    customerUpdateModel: CustomerUpdateModel;
}

export interface CrmCustomersUpdateTenantVendorAllocationRequest {
    id: string;
    vendorAllocationPatchModel: VendorAllocationPatchModel;
}

export interface CrmCustomersUpdateUserRequest {
    id: string;
    userId: string;
    customerUserUpdateModel: CustomerUserUpdateModel;
}

export interface CrmCustomersUploadCsvCustomersRequest {
    csvData: Blob;
}

export interface CrmCustomersUploadCsvForCustomerRequest {
    id: string;
    csvData: Blob;
}

/**
 * 
 */
export class CRMCustomersApi extends runtime.BaseAPI {

    /**
     * Creates a new customer account with profile information, installations, and initial configuration. Automatically creates associated user account and sends invitation email
     * Create New Customer
     */
    async crmCustomersAddAccountUserRaw(requestParameters: CrmCustomersAddAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedCustomerResponseModel>> {
        if (requestParameters.customerAddModel === null || requestParameters.customerAddModel === undefined) {
            throw new runtime.RequiredError('customerAddModel','Required parameter requestParameters.customerAddModel was null or undefined when calling crmCustomersAddAccountUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new customer account with profile information, installations, and initial configuration. Automatically creates associated user account and sends invitation email
     * Create New Customer
     */
    async crmCustomersAddAccountUser(requestParameters: CrmCustomersAddAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedCustomerResponseModel> {
        const response = await this.crmCustomersAddAccountUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint is planned for adding a customer to a sub-tenant but is not yet implemented. Will throw NotImplemented error
     * Add Customer to Sub-Tenant (Not Implemented)
     */
    async crmCustomersAddCustomerToSubtenantRaw(requestParameters: CrmCustomersAddCustomerToSubtenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersAddCustomerToSubtenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/customers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint is planned for adding a customer to a sub-tenant but is not yet implemented. Will throw NotImplemented error
     * Add Customer to Sub-Tenant (Not Implemented)
     */
    async crmCustomersAddCustomerToSubtenant(requestParameters: CrmCustomersAddCustomerToSubtenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersAddCustomerToSubtenantRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a technical customer account for system integrations. This endpoint is deprecated and will be removed - use the partners API instead for new integrations
     * Create Technical Customer (Deprecated)
     */
    async crmCustomersAddTechnicalCustomerRaw(requestParameters: CrmCustomersAddTechnicalCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedCustomerResponseModel>> {
        if (requestParameters.technicalCustomerAddModel === null || requestParameters.technicalCustomerAddModel === undefined) {
            throw new runtime.RequiredError('technicalCustomerAddModel','Required parameter requestParameters.technicalCustomerAddModel was null or undefined when calling crmCustomersAddTechnicalCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/technical`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.technicalCustomerAddModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a technical customer account for system integrations. This endpoint is deprecated and will be removed - use the partners API instead for new integrations
     * Create Technical Customer (Deprecated)
     */
    async crmCustomersAddTechnicalCustomer(requestParameters: CrmCustomersAddTechnicalCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedCustomerResponseModel> {
        const response = await this.crmCustomersAddTechnicalCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns a feature group to an existing customer, enabling specific features and capabilities. Can optionally update the ext_reference_1 field if included in the request payload
     * Assign Feature Group to Customer
     */
    async crmCustomersAssignFeatureGroupToCustomerRaw(requestParameters: CrmCustomersAssignFeatureGroupToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerFeatureGroupResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersAssignFeatureGroupToCustomer.');
        }

        if (requestParameters.customerAddFeatureGroupModel === null || requestParameters.customerAddFeatureGroupModel === undefined) {
            throw new runtime.RequiredError('customerAddFeatureGroupModel','Required parameter requestParameters.customerAddFeatureGroupModel was null or undefined when calling crmCustomersAssignFeatureGroupToCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/feature-groups-list`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerAddFeatureGroupModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Assigns a feature group to an existing customer, enabling specific features and capabilities. Can optionally update the ext_reference_1 field if included in the request payload
     * Assign Feature Group to Customer
     */
    async crmCustomersAssignFeatureGroupToCustomer(requestParameters: CrmCustomersAssignFeatureGroupToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerFeatureGroupResponseModel> {
        const response = await this.crmCustomersAssignFeatureGroupToCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves combined comparison data for a specific customer and configuration. Use this to compare energy device readings, consumption patterns, and historical data for analysis
     * Get Energy Device Comparison Data
     */
    async crmCustomersCompareCustomerDataRaw(requestParameters: CrmCustomersCompareCustomerDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerCompareModel>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling crmCustomersCompareCustomerData.');
        }

        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId','Required parameter requestParameters.configId was null or undefined when calling crmCustomersCompareCustomerData.');
        }

        const queryParameters: any = {};

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{customerId}/config/{configId}/compare`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))).replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves combined comparison data for a specific customer and configuration. Use this to compare energy device readings, consumption patterns, and historical data for analysis
     * Get Energy Device Comparison Data
     */
    async crmCustomersCompareCustomerData(requestParameters: CrmCustomersCompareCustomerDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerCompareModel> {
        const response = await this.crmCustomersCompareCustomerDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the physical address or zip code for a customer site. Changes the location information for the installation and may affect regional settings
     * Update Site Address
     */
    async crmCustomersCustomerChangeSiteAddressRaw(requestParameters: CrmCustomersCustomerChangeSiteAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerChangeSiteAddress.');
        }

        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling crmCustomersCustomerChangeSiteAddress.');
        }

        if (requestParameters.accountChangeAddressModel === null || requestParameters.accountChangeAddressModel === undefined) {
            throw new runtime.RequiredError('accountChangeAddressModel','Required parameter requestParameters.accountChangeAddressModel was null or undefined when calling crmCustomersCustomerChangeSiteAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/sites/{siteId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accountChangeAddressModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the physical address or zip code for a customer site. Changes the location information for the installation and may affect regional settings
     * Update Site Address
     */
    async crmCustomersCustomerChangeSiteAddress(requestParameters: CrmCustomersCustomerChangeSiteAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersCustomerChangeSiteAddressRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the Identity Provider (IDP) information for a customer including the dashboard URL needed for user impersonation and SSO configuration details
     * Get Customer Identity Provider Details
     */
    async crmCustomersCustomerGetIdpProviderRaw(requestParameters: CrmCustomersCustomerGetIdpProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerIdpProviderResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerGetIdpProvider.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/idpprovider`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the Identity Provider (IDP) information for a customer including the dashboard URL needed for user impersonation and SSO configuration details
     * Get Customer Identity Provider Details
     */
    async crmCustomersCustomerGetIdpProvider(requestParameters: CrmCustomersCustomerGetIdpProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerIdpProviderResponseModel> {
        const response = await this.crmCustomersCustomerGetIdpProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all sites (installations/locations) associated with a customer account. Each site represents a physical location with installations and devices
     * Get Customer Site List
     */
    async crmCustomersCustomerGetSitesRaw(requestParameters: CrmCustomersCustomerGetSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerGlobalSites>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerGetSites.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/sites`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all sites (installations/locations) associated with a customer account. Each site represents a physical location with installations and devices
     * Get Customer Site List
     */
    async crmCustomersCustomerGetSites(requestParameters: CrmCustomersCustomerGetSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerGlobalSites>> {
        const response = await this.crmCustomersCustomerGetSitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the user\'s email address in both the Identity Provider and the system. Sends verification emails to both old and new addresses to confirm the change
     * Change User Email Address
     */
    async crmCustomersCustomerUserChangeEmailRaw(requestParameters: CrmCustomersCustomerUserChangeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerUserChangeEmail.');
        }

        if (requestParameters.accountChangeEmailModel === null || requestParameters.accountChangeEmailModel === undefined) {
            throw new runtime.RequiredError('accountChangeEmailModel','Required parameter requestParameters.accountChangeEmailModel was null or undefined when calling crmCustomersCustomerUserChangeEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/email`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accountChangeEmailModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the user\'s email address in both the Identity Provider and the system. Sends verification emails to both old and new addresses to confirm the change
     * Change User Email Address
     */
    async crmCustomersCustomerUserChangeEmail(requestParameters: CrmCustomersCustomerUserChangeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersCustomerUserChangeEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Initiates password reset process for a user via the Identity Provider. Sends password reset link to the user\'s registered email address
     * Send Password Reset Email
     */
    async crmCustomersCustomerUserResetPasswordRaw(requestParameters: CrmCustomersCustomerUserResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerUserResetPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/resetpassword`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Initiates password reset process for a user via the Identity Provider. Sends password reset link to the user\'s registered email address
     * Send Password Reset Email
     */
    async crmCustomersCustomerUserResetPassword(requestParameters: CrmCustomersCustomerUserResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersCustomerUserResetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Triggers email validation process for a user in the Identity Provider. Sends verification email to confirm the user\'s email address
     * Send Email Validation Link
     */
    async crmCustomersCustomerUserValidateRaw(requestParameters: CrmCustomersCustomerUserValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersCustomerUserValidate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/validate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggers email validation process for a user in the Identity Provider. Sends verification email to confirm the user\'s email address
     * Send Email Validation Link
     */
    async crmCustomersCustomerUserValidate(requestParameters: CrmCustomersCustomerUserValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersCustomerUserValidateRaw(requestParameters, initOverrides);
    }

    /**
     * Marks customer account for deactivation with scheduled deletion after a set interval. Customer can be reactivated before permanent deletion. Use this for soft deletion with grace period
     * Deactivate Customer Account
     */
    async crmCustomersDeactivateCustomerRaw(requestParameters: CrmCustomersDeactivateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersDeactivateCustomer.');
        }

        if (requestParameters.customerDeactivateModel === null || requestParameters.customerDeactivateModel === undefined) {
            throw new runtime.RequiredError('customerDeactivateModel','Required parameter requestParameters.customerDeactivateModel was null or undefined when calling crmCustomersDeactivateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/deactivate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerDeactivateModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks customer account for deactivation with scheduled deletion after a set interval. Customer can be reactivated before permanent deletion. Use this for soft deletion with grace period
     * Deactivate Customer Account
     */
    async crmCustomersDeactivateCustomer(requestParameters: CrmCustomersDeactivateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersDeactivateCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a customer account. Requires confirmation token. Use purge flag for immediate deletion (requires additional permissions) or standard deletion for scheduled removal after grace period
     * Delete Customer Account
     */
    async crmCustomersDeleteCustomerRaw(requestParameters: CrmCustomersDeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersDeleteCustomer.');
        }

        if (requestParameters.customerRemoveModel === null || requestParameters.customerRemoveModel === undefined) {
            throw new runtime.RequiredError('customerRemoveModel','Required parameter requestParameters.customerRemoveModel was null or undefined when calling crmCustomersDeleteCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerRemoveModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a customer account. Requires confirmation token. Use purge flag for immediate deletion (requires additional permissions) or standard deletion for scheduled removal after grace period
     * Delete Customer Account
     */
    async crmCustomersDeleteCustomer(requestParameters: CrmCustomersDeleteCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersDeleteCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * Generates a temporary authentication token to access customer data on their behalf, such as for SSE API or dashboard impersonation. Token has limited lifetime and scope
     * Generate Temporary Access Token
     */
    async crmCustomersGetAuthTokensRaw(requestParameters: CrmCustomersGetAuthTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardAccessTokensModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetAuthTokens.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/token`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generates a temporary authentication token to access customer data on their behalf, such as for SSE API or dashboard impersonation. Token has limited lifetime and scope
     * Generate Temporary Access Token
     */
    async crmCustomersGetAuthTokens(requestParameters: CrmCustomersGetAuthTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardAccessTokensModel> {
        const response = await this.crmCustomersGetAuthTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all customers formatted for Content Management System integration. Optionally filter to include only system owners (parent customers with tenant management rights)
     * Get CMS Customer List
     */
    async crmCustomersGetCmsCustomersRaw(requestParameters: CrmCustomersGetCmsCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CmsCustomerModel>>> {
        const queryParameters: any = {};

        if (requestParameters.systemOwners !== undefined) {
            queryParameters['system_owners'] = requestParameters.systemOwners;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/cms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all customers formatted for Content Management System integration. Optionally filter to include only system owners (parent customers with tenant management rights)
     * Get CMS Customer List
     */
    async crmCustomersGetCmsCustomers(requestParameters: CrmCustomersGetCmsCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CmsCustomerModel>> {
        const response = await this.crmCustomersGetCmsCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated activity logs for all CSV customer import operations across all customers. Shows processing status, errors, and successful imports. Optional date filter available
     * Get All CSV Upload Processing Logs
     */
    async crmCustomersGetCsvUploadLogsRaw(requestParameters: CrmCustomersGetCsvUploadLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedActivityLogResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/upload/logs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves paginated activity logs for all CSV customer import operations across all customers. Shows processing status, errors, and successful imports. Optional date filter available
     * Get All CSV Upload Processing Logs
     */
    async crmCustomersGetCsvUploadLogs(requestParameters: CrmCustomersGetCsvUploadLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedActivityLogResponse> {
        const response = await this.crmCustomersGetCsvUploadLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated activity logs for CSV customer import operations for a specific customer. Shows processing status, errors, and successful imports. Optional date filter for specific time periods
     * Get Customer CSV Upload Processing Logs
     */
    async crmCustomersGetCsvUploadLogsForCustomerRaw(requestParameters: CrmCustomersGetCsvUploadLogsForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedActivityLogResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCsvUploadLogsForCustomer.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/upload/logs`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves paginated activity logs for CSV customer import operations for a specific customer. Shows processing status, errors, and successful imports. Optional date filter for specific time periods
     * Get Customer CSV Upload Processing Logs
     */
    async crmCustomersGetCsvUploadLogsForCustomer(requestParameters: CrmCustomersGetCsvUploadLogsForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedActivityLogResponse> {
        const response = await this.crmCustomersGetCsvUploadLogsForCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves comprehensive information about a specific customer including profile data, status, tenant information, subscriptions, and configuration settings
     * Get Customer Details
     */
    async crmCustomersGetCustomerRaw(requestParameters: CrmCustomersGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves comprehensive information about a specific customer including profile data, status, tenant information, subscriptions, and configuration settings
     * Get Customer Details
     */
    async crmCustomersGetCustomer(requestParameters: CrmCustomersGetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponseModel> {
        const response = await this.crmCustomersGetCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the list of vendors allocated to a customer based on their allocation configuration. Shows available device manufacturers and service providers for the customer
     * Get Customer Vendor Allocations
     */
    async crmCustomersGetCustomerAllocationsRaw(requestParameters: CrmCustomersGetCustomerAllocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VendorModel>>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling crmCustomersGetCustomerAllocations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{customerId}/allocations`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the list of vendors allocated to a customer based on their allocation configuration. Shows available device manufacturers and service providers for the customer
     * Get Customer Vendor Allocations
     */
    async crmCustomersGetCustomerAllocations(requestParameters: CrmCustomersGetCustomerAllocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VendorModel>> {
        const response = await this.crmCustomersGetCustomerAllocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all customers belonging to a sub-tenant (child tenant). Supports pagination, filtering, searching, and CSV export for hierarchical tenant management
     * Get Sub-Tenant Customers
     */
    async crmCustomersGetCustomerCustomersRaw(requestParameters: CrmCustomersGetCustomerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomersResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerCustomers.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.searchValue !== undefined) {
            queryParameters['searchValue'] = requestParameters.searchValue;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.csvExport !== undefined) {
            queryParameters['csvExport'] = requestParameters.csvExport;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/customers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all customers belonging to a sub-tenant (child tenant). Supports pagination, filtering, searching, and CSV export for hierarchical tenant management
     * Get Sub-Tenant Customers
     */
    async crmCustomersGetCustomerCustomers(requestParameters: CrmCustomersGetCustomerCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomersResponseModel> {
        const response = await this.crmCustomersGetCustomerCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves current gateway connection and health status for a specific customer, including online/offline state, signal strength, and last communication time
     * Get Current Gateway Status
     */
    async crmCustomersGetCustomerGatewayHealthRaw(requestParameters: CrmCustomersGetCustomerGatewayHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerGatewayHealthResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerGatewayHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/gateways/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves current gateway connection and health status for a specific customer, including online/offline state, signal strength, and last communication time
     * Get Current Gateway Status
     */
    async crmCustomersGetCustomerGatewayHealth(requestParameters: CrmCustomersGetCustomerGatewayHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerGatewayHealthResponseModel> {
        const response = await this.crmCustomersGetCustomerGatewayHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves historical gateway status data for a specific customer, showing connectivity patterns, uptime history, and past communication issues
     * Get Customer Gateway Status History
     */
    async crmCustomersGetCustomerGatewayHealthHistoryRaw(requestParameters: CrmCustomersGetCustomerGatewayHealthHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerGatewayHealthResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerGatewayHealthHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/gateways/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves historical gateway status data for a specific customer, showing connectivity patterns, uptime history, and past communication issues
     * Get Customer Gateway Status History
     */
    async crmCustomersGetCustomerGatewayHealthHistory(requestParameters: CrmCustomersGetCustomerGatewayHealthHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerGatewayHealthResponseModel> {
        const response = await this.crmCustomersGetCustomerGatewayHealthHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves installation-specific key performance indicators for a customer including device counts, types, vendors, and configuration metrics
     * Get Customer Installation KPI Statistics
     */
    async crmCustomersGetCustomerInstallationsStatsRaw(requestParameters: CrmCustomersGetCustomerInstallationsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationStatsModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerInstallationsStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/stats/installations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves installation-specific key performance indicators for a customer including device counts, types, vendors, and configuration metrics
     * Get Customer Installation KPI Statistics
     */
    async crmCustomersGetCustomerInstallationsStats(requestParameters: CrmCustomersGetCustomerInstallationsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationStatsModel> {
        const response = await this.crmCustomersGetCustomerInstallationsStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves key performance indicators for a specific customer by UUID, including metrics about installations, users, and activity. Supports filtering for detailed analysis
     * Get Customer-Specific KPI Statistics
     */
    async crmCustomersGetCustomerStatsRaw(requestParameters: CrmCustomersGetCustomerStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStats>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/stats`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves key performance indicators for a specific customer by UUID, including metrics about installations, users, and activity. Supports filtering for detailed analysis
     * Get Customer-Specific KPI Statistics
     */
    async crmCustomersGetCustomerStats(requestParameters: CrmCustomersGetCustomerStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStats> {
        const response = await this.crmCustomersGetCustomerStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves statistics for a specific customer including detailed list of child records for deeper analysis and breakdown of metrics
     * Get Customer Statistics with Child Records
     */
    async crmCustomersGetCustomerStatsChildrenRaw(requestParameters: CrmCustomersGetCustomerStatsChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStatsChildren>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerStatsChildren.');
        }

        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/stats/children`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves statistics for a specific customer including detailed list of child records for deeper analysis and breakdown of metrics
     * Get Customer Statistics with Child Records
     */
    async crmCustomersGetCustomerStatsChildren(requestParameters: CrmCustomersGetCustomerStatsChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStatsChildren> {
        const response = await this.crmCustomersGetCustomerStatsChildrenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the tenant affiliate relationship information for a customer, showing organizational hierarchy and affiliate configurations
     * Get Customer Tenant Affiliate
     */
    async crmCustomersGetCustomerTenantAffiliateRaw(requestParameters: CrmCustomersGetCustomerTenantAffiliateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantAffiliateResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerTenantAffiliate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/tenant-affiliate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the tenant affiliate relationship information for a customer, showing organizational hierarchy and affiliate configurations
     * Get Customer Tenant Affiliate
     */
    async crmCustomersGetCustomerTenantAffiliate(requestParameters: CrmCustomersGetCustomerTenantAffiliateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantAffiliateResponseModel> {
        const response = await this.crmCustomersGetCustomerTenantAffiliateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks customer\'s gateway readiness for Time-of-Use (ToU) tariff functionality. Returns compatibility status, required updates, and readiness indicators for ToU billing
     * Get Time-of-Use Readiness Status
     */
    async crmCustomersGetCustomerTouReadinessCheckRaw(requestParameters: CrmCustomersGetCustomerTouReadinessCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GatewayToUReadinessResponseModel>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling crmCustomersGetCustomerTouReadinessCheck.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{customerId}/touReadinessCheck`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Checks customer\'s gateway readiness for Time-of-Use (ToU) tariff functionality. Returns compatibility status, required updates, and readiness indicators for ToU billing
     * Get Time-of-Use Readiness Status
     */
    async crmCustomersGetCustomerTouReadinessCheck(requestParameters: CrmCustomersGetCustomerTouReadinessCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GatewayToUReadinessResponseModel> {
        const response = await this.crmCustomersGetCustomerTouReadinessCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves comprehensive information about a specific user including profile, roles, permissions, authentication details, and activity history
     * Get Detailed User Information
     */
    async crmCustomersGetCustomerUserRaw(requestParameters: CrmCustomersGetCustomerUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerUserMainResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling crmCustomersGetCustomerUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/users/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves comprehensive information about a specific user including profile, roles, permissions, authentication details, and activity history
     * Get Detailed User Information
     */
    async crmCustomersGetCustomerUser(requestParameters: CrmCustomersGetCustomerUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerUserMainResponseModel> {
        const response = await this.crmCustomersGetCustomerUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves basic profile information for a specific user within a customer account. Returns limited user details without sensitive data
     * Get Basic User Information
     */
    async crmCustomersGetCustomerUserBasicRaw(requestParameters: CrmCustomersGetCustomerUserBasicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerBasicResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerUserBasic.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling crmCustomersGetCustomerUserBasic.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/users/{userId}/basic`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves basic profile information for a specific user within a customer account. Returns limited user details without sensitive data
     * Get Basic User Information
     */
    async crmCustomersGetCustomerUserBasic(requestParameters: CrmCustomersGetCustomerUserBasicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerBasicResponseModel> {
        const response = await this.crmCustomersGetCustomerUserBasicRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves user details by customer ID and tenant-specific user UID. Response includes enriched tenant name and hierarchical organization information
     * Get User with Tenant Information
     */
    async crmCustomersGetCustomerUserIncludingTenantNameRaw(requestParameters: CrmCustomersGetCustomerUserIncludingTenantNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerUserIncludingTenantName.');
        }

        if (requestParameters.tenantUserUid === null || requestParameters.tenantUserUid === undefined) {
            throw new runtime.RequiredError('tenantUserUid','Required parameter requestParameters.tenantUserUid was null or undefined when calling crmCustomersGetCustomerUserIncludingTenantName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/tenant/{tenantUserUid}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"tenantUserUid"}}`, encodeURIComponent(String(requestParameters.tenantUserUid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves user details by customer ID and tenant-specific user UID. Response includes enriched tenant name and hierarchical organization information
     * Get User with Tenant Information
     */
    async crmCustomersGetCustomerUserIncludingTenantName(requestParameters: CrmCustomersGetCustomerUserIncludingTenantNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.crmCustomersGetCustomerUserIncludingTenantNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all users associated with a specific customer account, including their roles, status, and profile information
     * Get Customer Users
     */
    async crmCustomersGetCustomerUsersRaw(requestParameters: CrmCustomersGetCustomerUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerUserResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetCustomerUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/users`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all users associated with a specific customer account, including their roles, status, and profile information
     * Get Customer Users
     */
    async crmCustomersGetCustomerUsers(requestParameters: CrmCustomersGetCustomerUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerUserResponseModel>> {
        const response = await this.crmCustomersGetCustomerUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of customers with support for filtering, searching, sorting, and CSV export. Use this endpoint for customer overviews and bulk data export
     * Get Paginated List of Customers
     */
    async crmCustomersGetCustomersRaw(requestParameters: CrmCustomersGetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomersResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.searchValue !== undefined) {
            queryParameters['searchValue'] = requestParameters.searchValue;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.csvExport !== undefined) {
            queryParameters['csvExport'] = requestParameters.csvExport;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of customers with support for filtering, searching, sorting, and CSV export. Use this endpoint for customer overviews and bulk data export
     * Get Paginated List of Customers
     */
    async crmCustomersGetCustomers(requestParameters: CrmCustomersGetCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomersResponseModel> {
        const response = await this.crmCustomersGetCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves gateway communication and health alarms for all customers. Returns all non-OK gateways by default, or filters by specific alarm level to identify connectivity issues
     * Get Gateway Alarm Status
     */
    async crmCustomersGetInstallationsGatewayAlarmsRaw(requestParameters: CrmCustomersGetInstallationsGatewayAlarmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerGatewayHealthResponseModel>>> {
        const queryParameters: any = {};

        if (requestParameters.alarmLevel !== undefined) {
            queryParameters['alarmLevel'] = requestParameters.alarmLevel;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/installations/gateways/alarms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves gateway communication and health alarms for all customers. Returns all non-OK gateways by default, or filters by specific alarm level to identify connectivity issues
     * Get Gateway Alarm Status
     */
    async crmCustomersGetInstallationsGatewayAlarms(requestParameters: CrmCustomersGetInstallationsGatewayAlarmsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerGatewayHealthResponseModel>> {
        const response = await this.crmCustomersGetInstallationsGatewayAlarmsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves health status for installations of specified customers. This endpoint is deprecated - use POST /api/v1/customers/health/sites instead for improved performance and features
     * Get Installation Health Status (Deprecated)
     */
    async crmCustomersGetInstallationsHealthRaw(requestParameters: CrmCustomersGetInstallationsHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthStatusModel>> {
        if (requestParameters.healthStatusRequest === null || requestParameters.healthStatusRequest === undefined) {
            throw new runtime.RequiredError('healthStatusRequest','Required parameter requestParameters.healthStatusRequest was null or undefined when calling crmCustomersGetInstallationsHealth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/installations/health`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.healthStatusRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves health status for installations of specified customers. This endpoint is deprecated - use POST /api/v1/customers/health/sites instead for improved performance and features
     * Get Installation Health Status (Deprecated)
     */
    async crmCustomersGetInstallationsHealth(requestParameters: CrmCustomersGetInstallationsHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthStatusModel> {
        const response = await this.crmCustomersGetInstallationsHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all installation health alarms across all customers. Filter by alarm severity level and active/resolved status to identify critical issues requiring attention
     * Get Installation Health Alarms
     */
    async crmCustomersGetInstallationsHealthAlarmsRaw(requestParameters: CrmCustomersGetInstallationsHealthAlarmsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthStatusAlarmsModel>> {
        const queryParameters: any = {};

        if (requestParameters.alarmLevel !== undefined) {
            queryParameters['alarmLevel'] = requestParameters.alarmLevel;
        }

        if (requestParameters.active !== undefined) {
            queryParameters['active'] = requestParameters.active;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/installations/health/alarms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all installation health alarms across all customers. Filter by alarm severity level and active/resolved status to identify critical issues requiring attention
     * Get Installation Health Alarms
     */
    async crmCustomersGetInstallationsHealthAlarms(requestParameters: CrmCustomersGetInstallationsHealthAlarmsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthStatusAlarmsModel> {
        const response = await this.crmCustomersGetInstallationsHealthAlarmsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all installation health alarms for a specific customer. Use this to diagnose installation issues or monitor system health for individual customers
     * Get Customer-Specific Installation Alarms
     */
    async crmCustomersGetInstallationsHealthAlarmsByCustomerIdRaw(requestParameters: CrmCustomersGetInstallationsHealthAlarmsByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthStatusAlarmsModel>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling crmCustomersGetInstallationsHealthAlarmsByCustomerId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/installations/health/alarms/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all installation health alarms for a specific customer. Use this to diagnose installation issues or monitor system health for individual customers
     * Get Customer-Specific Installation Alarms
     */
    async crmCustomersGetInstallationsHealthAlarmsByCustomerId(requestParameters: CrmCustomersGetInstallationsHealthAlarmsByCustomerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthStatusAlarmsModel> {
        const response = await this.crmCustomersGetInstallationsHealthAlarmsByCustomerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves key performance indicators for installations including device counts, installation types, vendor distribution, and configuration statistics across all customers
     * Get Installation KPI Statistics
     */
    async crmCustomersGetInstallationsStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationStatsModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/stats/installations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves key performance indicators for installations including device counts, installation types, vendor distribution, and configuration statistics across all customers
     * Get Installation KPI Statistics
     */
    async crmCustomersGetInstallationsStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationStatsModel> {
        const response = await this.crmCustomersGetInstallationsStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the complete history of invitation emails sent to a user, including timestamps, delivery status, and invitation types (signup, password reset, etc.)
     * Get User Invitation History
     */
    async crmCustomersGetSendAccountUserInvitationsRaw(requestParameters: CrmCustomersGetSendAccountUserInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SentInvitationResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetSendAccountUserInvitations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/sendinvitation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the complete history of invitation emails sent to a user, including timestamps, delivery status, and invitation types (signup, password reset, etc.)
     * Get User Invitation History
     */
    async crmCustomersGetSendAccountUserInvitations(requestParameters: CrmCustomersGetSendAccountUserInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SentInvitationResponseModel>> {
        const response = await this.crmCustomersGetSendAccountUserInvitationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the history of email campaigns sent to a specific user, including campaign types, send dates, and delivery status
     * Get User Email Campaign History
     */
    async crmCustomersGetSendUserEmailCampaignsRaw(requestParameters: CrmCustomersGetSendUserEmailCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersGetSendUserEmailCampaigns.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/email-campaigns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the history of email campaigns sent to a specific user, including campaign types, send dates, and delivery status
     * Get User Email Campaign History
     */
    async crmCustomersGetSendUserEmailCampaigns(requestParameters: CrmCustomersGetSendUserEmailCampaignsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.crmCustomersGetSendUserEmailCampaignsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves key performance indicators (KPIs) for customers including total counts, active/inactive breakdown, registration trends, and other metrics. Supports filtering by customer attributes
     * Get Customer KPI Statistics
     */
    async crmCustomersGetStatsRaw(requestParameters: CrmCustomersGetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStats>> {
        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves key performance indicators (KPIs) for customers including total counts, active/inactive breakdown, registration trends, and other metrics. Supports filtering by customer attributes
     * Get Customer KPI Statistics
     */
    async crmCustomersGetStats(requestParameters: CrmCustomersGetStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStats> {
        const response = await this.crmCustomersGetStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves customer statistics including detailed list of individual child customer records. Use this for detailed breakdowns and customer-level analysis within aggregated data
     * Get Customer Statistics with Child Records
     */
    async crmCustomersGetStatsCustomersRaw(requestParameters: CrmCustomersGetStatsCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerStatsChildren>> {
        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/stats/children`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves customer statistics including detailed list of individual child customer records. Use this for detailed breakdowns and customer-level analysis within aggregated data
     * Get Customer Statistics with Child Records
     */
    async crmCustomersGetStatsCustomers(requestParameters: CrmCustomersGetStatsCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerStatsChildren> {
        const response = await this.crmCustomersGetStatsCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancels scheduled deletion and reactivates a deactivated customer account. Restores full access and removes deletion marker. Must be called before permanent deletion occurs
     * Reactivate Customer Account
     */
    async crmCustomersReactivateCustomerRaw(requestParameters: CrmCustomersReactivateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserReactivationModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersReactivateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/reactivate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancels scheduled deletion and reactivates a deactivated customer account. Restores full access and removes deletion marker. Must be called before permanent deletion occurs
     * Reactivate Customer Account
     */
    async crmCustomersReactivateCustomer(requestParameters: CrmCustomersReactivateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserReactivationModel> {
        const response = await this.crmCustomersReactivateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes an assigned feature group from a customer, disabling associated features and capabilities. This does not delete the feature group itself, only the assignment
     * Remove Feature Group from Customer
     */
    async crmCustomersRemoveAssignedToCustomerFeatureGroupRaw(requestParameters: CrmCustomersRemoveAssignedToCustomerFeatureGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerFeatureGroupResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersRemoveAssignedToCustomerFeatureGroup.');
        }

        if (requestParameters.customerRemoveFeatureGroupModel === null || requestParameters.customerRemoveFeatureGroupModel === undefined) {
            throw new runtime.RequiredError('customerRemoveFeatureGroupModel','Required parameter requestParameters.customerRemoveFeatureGroupModel was null or undefined when calling crmCustomersRemoveAssignedToCustomerFeatureGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/feature-groups-list`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerRemoveFeatureGroupModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Removes an assigned feature group from a customer, disabling associated features and capabilities. This does not delete the feature group itself, only the assignment
     * Remove Feature Group from Customer
     */
    async crmCustomersRemoveAssignedToCustomerFeatureGroup(requestParameters: CrmCustomersRemoveAssignedToCustomerFeatureGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerFeatureGroupResponseModel> {
        const response = await this.crmCustomersRemoveAssignedToCustomerFeatureGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends or resends an invitation email to a user with signup link and account activation instructions. Use this to invite new users or resend expired invitations
     * Send User Invitation Email
     */
    async crmCustomersSendAccountUserInvitationRaw(requestParameters: CrmCustomersSendAccountUserInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersSendAccountUserInvitation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/users/{id}/sendinvitation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sends or resends an invitation email to a user with signup link and account activation instructions. Use this to invite new users or resend expired invitations
     * Send User Invitation Email
     */
    async crmCustomersSendAccountUserInvitation(requestParameters: CrmCustomersSendAccountUserInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.crmCustomersSendAccountUserInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes the subscription or service package for a customer. Updates available features, service levels, and billing tier. Validates compatibility with existing installations
     * Update Customer Subscription Package
     */
    async crmCustomersUpdateAccountSubscriptionRaw(requestParameters: CrmCustomersUpdateAccountSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUpdateAccountSubscription.');
        }

        if (requestParameters.customerChangeSubscriptionsModel === null || requestParameters.customerChangeSubscriptionsModel === undefined) {
            throw new runtime.RequiredError('customerChangeSubscriptionsModel','Required parameter requestParameters.customerChangeSubscriptionsModel was null or undefined when calling crmCustomersUpdateAccountSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/subscription`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerChangeSubscriptionsModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Changes the subscription or service package for a customer. Updates available features, service levels, and billing tier. Validates compatibility with existing installations
     * Update Customer Subscription Package
     */
    async crmCustomersUpdateAccountSubscription(requestParameters: CrmCustomersUpdateAccountSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponseModel> {
        const response = await this.crmCustomersUpdateAccountSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the tenant/organization assignment for a customer. Use this to move customers between organizational hierarchies or update parent-child relationships
     * Change Customer Tenant
     */
    async crmCustomersUpdateAccountUserRaw(requestParameters: CrmCustomersUpdateAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUpdateAccountUser.');
        }

        if (requestParameters.customerChangeTenantModel === null || requestParameters.customerChangeTenantModel === undefined) {
            throw new runtime.RequiredError('customerChangeTenantModel','Required parameter requestParameters.customerChangeTenantModel was null or undefined when calling crmCustomersUpdateAccountUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/tenant`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerChangeTenantModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates the tenant/organization assignment for a customer. Use this to move customers between organizational hierarchies or update parent-child relationships
     * Change Customer Tenant
     */
    async crmCustomersUpdateAccountUser(requestParameters: CrmCustomersUpdateAccountUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponseModel> {
        const response = await this.crmCustomersUpdateAccountUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates customer profile information, settings, and configuration. Supports partial updates and validates changes against business rules and tenant scope
     * Update Customer Information
     */
    async crmCustomersUpdateCustomerRaw(requestParameters: CrmCustomersUpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUpdateCustomer.');
        }

        if (requestParameters.customerUpdateModel === null || requestParameters.customerUpdateModel === undefined) {
            throw new runtime.RequiredError('customerUpdateModel','Required parameter requestParameters.customerUpdateModel was null or undefined when calling crmCustomersUpdateCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerUpdateModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates customer profile information, settings, and configuration. Supports partial updates and validates changes against business rules and tenant scope
     * Update Customer Information
     */
    async crmCustomersUpdateCustomer(requestParameters: CrmCustomersUpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerResponseModel> {
        const response = await this.crmCustomersUpdateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update vendor allocation for a tenant. Requires owner/admin access.
     * Update tenant vendor allocation
     */
    async crmCustomersUpdateTenantVendorAllocationRaw(requestParameters: CrmCustomersUpdateTenantVendorAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUpdateTenantVendorAllocation.');
        }

        if (requestParameters.vendorAllocationPatchModel === null || requestParameters.vendorAllocationPatchModel === undefined) {
            throw new runtime.RequiredError('vendorAllocationPatchModel','Required parameter requestParameters.vendorAllocationPatchModel was null or undefined when calling crmCustomersUpdateTenantVendorAllocation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/vendor-allocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.vendorAllocationPatchModel,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update vendor allocation for a tenant. Requires owner/admin access.
     * Update tenant vendor allocation
     */
    async crmCustomersUpdateTenantVendorAllocation(requestParameters: CrmCustomersUpdateTenantVendorAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.crmCustomersUpdateTenantVendorAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates user profile information, roles, or settings for a specific user within a customer account. Supports partial updates
     * Update Customer User
     */
    async crmCustomersUpdateUserRaw(requestParameters: CrmCustomersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUpdateUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling crmCustomersUpdateUser.');
        }

        if (requestParameters.customerUserUpdateModel === null || requestParameters.customerUserUpdateModel === undefined) {
            throw new runtime.RequiredError('customerUserUpdateModel','Required parameter requestParameters.customerUserUpdateModel was null or undefined when calling crmCustomersUpdateUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/users/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.customerUserUpdateModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates user profile information, roles, or settings for a specific user within a customer account. Supports partial updates
     * Update Customer User
     */
    async crmCustomersUpdateUser(requestParameters: CrmCustomersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmCustomersUpdateUserRaw(requestParameters, initOverrides);
    }

    /**
     * Uploads a CSV file for bulk customer creation. The file is processed asynchronously to create multiple customers. Monitor processing status via upload logs endpoint
     * Upload CSV File for Bulk Customer Creation
     */
    async crmCustomersUploadCsvCustomersRaw(requestParameters: CrmCustomersUploadCsvCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.csvData === null || requestParameters.csvData === undefined) {
            throw new runtime.RequiredError('csvData','Required parameter requestParameters.csvData was null or undefined when calling crmCustomersUploadCsvCustomers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.csvData !== undefined) {
            formParams.append('csvData', requestParameters.csvData as any);
        }

        const response = await this.request({
            path: `/api/v1/customers/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Uploads a CSV file for bulk customer creation. The file is processed asynchronously to create multiple customers. Monitor processing status via upload logs endpoint
     * Upload CSV File for Bulk Customer Creation
     */
    async crmCustomersUploadCsvCustomers(requestParameters: CrmCustomersUploadCsvCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.crmCustomersUploadCsvCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uploads a CSV file on behalf of a specific customer for bulk customer creation. The file is processed asynchronously and customers are created based on CSV data. Check upload logs for processing status
     * Upload Customer CSV File for Bulk Import
     */
    async crmCustomersUploadCsvForCustomerRaw(requestParameters: CrmCustomersUploadCsvForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmCustomersUploadCsvForCustomer.');
        }

        if (requestParameters.csvData === null || requestParameters.csvData === undefined) {
            throw new runtime.RequiredError('csvData','Required parameter requestParameters.csvData was null or undefined when calling crmCustomersUploadCsvForCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.csvData !== undefined) {
            formParams.append('csvData', requestParameters.csvData as any);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/upload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Uploads a CSV file on behalf of a specific customer for bulk customer creation. The file is processed asynchronously and customers are created based on CSV data. Check upload logs for processing status
     * Upload Customer CSV File for Bulk Import
     */
    async crmCustomersUploadCsvForCustomer(requestParameters: CrmCustomersUploadCsvForCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.crmCustomersUploadCsvForCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
